import { algoliasearch } from "algoliasearch";

const searchClient = algoliasearch("ZV9CMEOHVR", "6fe7688757de7afc15332cb6b0b5c911");

export default searchClient;
